/* CLNK in-house card designer.
 * CR80 spec (locked, from card-templates/clnk-card-spec-system.json):
 * trim 1011x638 px @300dpi (85.6x53.98mm), corner r=38px, safe inset 47px,
 * chip center 18.55/20.40mm; large chip 13x12mm, small 12x10mm.
 * Output: line item properties on the product form (works with theme FormData
 * add-to-cart): Name/Line 2/Hebrew/Font/Engrave/_Design JSON/_Preview + native
 * file upload property for the original photo.
 */
(function () {
  var root = document.getElementById('clnk-designer');
  if (!root) return;
  var cv = document.getElementById('clnk-canvas');
  var ctx = cv.getContext('2d');
  var S = 1011 / 85.6; // px per mm
  var CHIP_C = { x: 18.55 * S, y: 20.40 * S };
  var CHIPS = { large: { w: 13 * S, h: 12 * S }, small: { w: 12 * S, h: 10 * S } };
  var COLORS = {
    black: { top: '#2c2c2e', bot: '#0a0a0a', ink: '#d7d7d7' },
    gold: { top: '#e6c45c', bot: '#9a7a1f', ink: '#1c1505' },
    silver: { top: '#e8e8ea', bot: '#a5a5ab', ink: '#1f1f24' }
  };
  var st = { color: 'black', chip: 'none', photo: null, scale: 0.6, px: 0.68, py: 0.5, guides: true };
  var form = document.querySelector('form[action*="/cart/add"]');

  function el(id) { return document.getElementById(id); }
  function val(id) { var e = el(id); return e ? e.value : ''; }

  // ---- variant detection (color + chip) from the product form ----
  function selectedText() {
    if (!form) return '';
    var parts = [];
    form.querySelectorAll('select').forEach(function (s) { parts.push(s.value); });
    form.querySelectorAll('input[type=radio]:checked').forEach(function (r) { parts.push(r.value); });
    return parts.join(' ').toLowerCase();
  }
  function syncVariant() {
    var t = selectedText();
    var ov = val('clnk-color');
    if (ov && ov !== 'auto') st.color = ov;
    else if (t.indexOf('gold') > -1) st.color = 'gold';
    else if (t.indexOf('silver') > -1) st.color = 'silver';
    else st.color = 'black';
    if (t.indexOf('large chip') > -1) st.chip = 'large';
    else if (t.indexOf('small chip') > -1) st.chip = 'small';
    else st.chip = 'none';
  }

  function rr(x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function draw() {
    syncVariant();
    var c = COLORS[st.color];
    ctx.clearRect(0, 0, 1011, 638);
    rr(0, 0, 1011, 638, 38);
    ctx.save(); ctx.clip();
    var g = ctx.createLinearGradient(0, 0, 1011, 638);
    g.addColorStop(0, c.top); g.addColorStop(1, c.bot);
    ctx.fillStyle = g; ctx.fillRect(0, 0, 1011, 638);
    // brushed-metal sheen
    var sh = ctx.createLinearGradient(0, 0, 1011, 0);
    sh.addColorStop(0, 'rgba(255,255,255,0)'); sh.addColorStop(0.45, 'rgba(255,255,255,.10)'); sh.addColorStop(0.55, 'rgba(255,255,255,.10)'); sh.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = sh; ctx.fillRect(0, 0, 1011, 638);
    // photo
    if (st.photo) {
      var iw = st.photo.width * st.scale, ih = st.photo.height * st.scale;
      ctx.drawImage(st.photo, st.px * 1011 - iw / 2, st.py * 638 - ih / 2, iw, ih);
    }
    // chip window
    if (st.chip !== 'none') {
      var ch = CHIPS[st.chip];
      ctx.fillStyle = 'rgba(212,175,55,.92)';
      rr(CHIP_C.x - ch.w / 2, CHIP_C.y - ch.h / 2, ch.w, ch.h, 10);
      ctx.fill();
      ctx.strokeStyle = 'rgba(0,0,0,.35)'; ctx.lineWidth = 2; ctx.stroke();
      ctx.strokeStyle = 'rgba(0,0,0,.25)'; ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(CHIP_C.x - ch.w / 2 + 8, CHIP_C.y); ctx.lineTo(CHIP_C.x + ch.w / 2 - 8, CHIP_C.y);
      ctx.moveTo(CHIP_C.x, CHIP_C.y - ch.h / 2 + 6); ctx.lineTo(CHIP_C.x, CHIP_C.y + ch.h / 2 - 6);
      ctx.stroke();
    }
    // text
    var ink = val('clnk-engrave');
    if (!ink || ink === 'auto') ink = c.ink;
    var font = val('clnk-font') || 'Georgia';
    ctx.fillStyle = ink;
    ctx.shadowColor = 'rgba(0,0,0,.45)'; ctx.shadowBlur = 3; ctx.shadowOffsetY = 1.5;
    var name = val('clnk-name');
    if (name) { ctx.font = '600 52px ' + font; ctx.fillText(name.toUpperCase(), 60, 540, 891); }
    var l2 = val('clnk-line2');
    if (l2) { ctx.font = '30px ' + font; ctx.fillText(l2, 60, 585, 891); }
    var heb = val('clnk-hebrew');
    if (heb) { ctx.font = '600 44px ' + font; ctx.textAlign = 'right'; ctx.direction = 'rtl'; ctx.fillText(heb, 951, 120, 760); ctx.textAlign = 'left'; ctx.direction = 'ltr'; }
    ctx.shadowColor = 'transparent';
    // guides
    if (st.guides) {
      ctx.strokeStyle = 'rgba(0,200,255,.8)'; ctx.setLineDash([10, 8]); ctx.lineWidth = 2;
      ctx.strokeRect(47, 47, 917, 543);
      if (st.chip !== 'none') {
        var kc = { w: 16 * S, h: 16 * S };
        ctx.strokeStyle = 'rgba(255,120,0,.8)';
        ctx.strokeRect(CHIP_C.x - kc.w / 2, CHIP_C.y - kc.h / 2, kc.w, kc.h);
      }
      ctx.setLineDash([]);
    }
    ctx.restore();
    syncProperties();
  }

  // ---- order properties ----
  function prop(name) {
    if (!form) return null;
    var sel = 'input[name="properties[' + name + ']"]';
    var i = form.querySelector(sel);
    if (!i) {
      i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + name + ']';
      form.appendChild(i);
    }
    return i;
  }
  var thumbTimer = null;
  function syncProperties() {
    if (!form) return;
    prop('Name on Card').value = val('clnk-name');
    prop('Line 2').value = val('clnk-line2');
    prop('Hebrew Text').value = val('clnk-hebrew');
    prop('Lettering').value = val('clnk-font');
    prop('Engrave Finish').value = val('clnk-engrave');
    prop('_Design JSON').value = JSON.stringify({ v: 1, color: st.color, chip: st.chip, scale: st.scale, px: st.px, py: st.py, hasPhoto: !!st.photo });
    clearTimeout(thumbTimer);
    thumbTimer = setTimeout(function () {
      try {
        var t = document.createElement('canvas'); t.width = 320; t.height = 202;
        t.getContext('2d').drawImage(cv, 0, 0, 320, 202);
        prop('_Preview').value = t.toDataURL('image/jpeg', 0.5);
      } catch (e) { /* tainted canvas etc — preview optional */ }
    }, 400);
  }

  // ---- photo: preview + native file property for the order ----
  var photoInput = el('clnk-photo');
  if (photoInput && form) {
    var orderFile = document.createElement('input');
    orderFile.type = 'file'; orderFile.name = 'properties[Your Photo]';
    orderFile.style.display = 'none';
    form.appendChild(orderFile);
    form.enctype = 'multipart/form-data';
    photoInput.addEventListener('change', function () {
      var f = photoInput.files && photoInput.files[0];
      if (!f) return;
      try { var dt = new DataTransfer(); dt.items.add(f); orderFile.files = dt.files; } catch (e) {}
      var img = new Image();
      img.onload = function () { st.photo = img; st.scale = Math.min(600 / img.width, 1); draw(); };
      img.src = URL.createObjectURL(f);
    });
  }

  // ---- control wiring ----
  [['clnk-scale', function (v) { st.scale = v / 100; }],
   ['clnk-px', function (v) { st.px = v / 100; }],
   ['clnk-py', function (v) { st.py = v / 100; }]].forEach(function (p) {
    var e = el(p[0]);
    if (e) e.addEventListener('input', function () { p[1](parseFloat(e.value)); draw(); });
  });
  ['clnk-name', 'clnk-line2', 'clnk-hebrew'].forEach(function (id) {
    var e = el(id); if (e) e.addEventListener('input', draw);
  });
  ['clnk-font', 'clnk-engrave', 'clnk-color'].forEach(function (id) {
    var e = el(id); if (e) e.addEventListener('change', draw);
  });
  var gd = el('clnk-guides');
  if (gd) gd.addEventListener('change', function () { st.guides = gd.checked; draw(); });
  if (form) form.addEventListener('change', function () { setTimeout(draw, 50); });
  document.addEventListener('variant:change', function () { setTimeout(draw, 50); });
  draw();
})();
